// extracted by mini-css-extract-plugin
export default {"searchInput":"Search_searchInput__mwG35","pinIcon":"Search_pinIcon__Q2WgI"};